/** @jsx jsx */
import React, { Fragment as _, useEffect } from 'react';
import { css, jsx } from '@emotion/core';

const Li = ({ attributes, children }) => {
  useEffect(() => {
    const li = attributes.ref.current;
    let _fontFamily = '';
    let _color = '';
    Array.from(li.querySelectorAll('span')).forEach((span: any) => {
      //
      if (span.closest('a')) {
        return;
      }

      const { fontFamily, color } = span.style;
      if (fontFamily && !_fontFamily) _fontFamily = fontFamily;
      if (color && !_color) _color = color;
    });

    li.style.fontFamily = _fontFamily;
    li.style.color = _color;
  });

  return <li {...attributes}>{children}</li>;
};

const renderNode = (props, editor, next) => {
  const { attributes, children, node, isFocused } = props;

  let style;
  try {
    style = props.node.data.toJS().style || {};
  } catch (err) {
    console.warn('!!!');
  }

  switch (node.type) {
    case 'list-item':
      // return <Li attributes={attributes}>{children}</Li>;
      return <li {...attributes}>{children}</li>;

    case 'bulleted-list':
      return (
        <ul className="chameleon-ul" {...attributes}>
          {children}
        </ul>
      );

    case 'numbered-list':
      return (
        <ol className="chameleon-ol" {...attributes}>
          {children}
        </ol>
      );

    case 'indented-list':
      return (
        <ul className="indented-list" {...attributes}>
          {children}
        </ul>
      );

    case 'indented':
      return (
        <div className="indented" {...attributes}>
          {children}
        </div>
      );

    case 'textAlignLeft':
      return (
        <div {...attributes} style={{ textAlign: 'left' }}>
          {children}
        </div>
      );

    case 'textAlignCenter':
      return (
        <div {...attributes} style={{ textAlign: 'center' }}>
          {children}
        </div>
      );

    case 'textAlignRight':
      return (
        <div {...attributes} style={{ textAlign: 'right' }}>
          {children}
        </div>
      );

    case 'heading-one':
      return (
        <h1 style={style} {...attributes}>
          {children}
        </h1>
      );

    case 'heading-two':
      return (
        <h2 style={style} {...attributes}>
          {children}
        </h2>
      );

    case 'heading-three':
      return (
        <h3 style={style} {...attributes}>
          {children}
        </h3>
      );

    case 'paragraph': {
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      );
    }

    case 'code': {
      return (
        <pre style={style} {...attributes}>
          <code>{children}</code>
        </pre>
      );
    }

    default:
      return next();
  }
};

export default renderNode;
